import { CourseMaterial, useProgramDetails } from "./coursesLoader";

export default function useOptedIn(material: CourseMaterial) {
  const { userEffectiveProgram } = useProgramDetails();
  switch (userEffectiveProgram) {
    case "equitable_access":
      return true;
    case "inclusive_access":
      return !material.optOut;
    case "no_program":
      return false;
  }
}
